import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_route_tab = _resolveComponent("q-route-tab")!

  return (_openBlock(), _createBlock(_component_q_route_tab, _mergeProps({
    to: "/unreviewed",
    name: "unreviewed",
    label: _ctx.label,
    exact: ""
  }, _ctx.$attrs), null, 16, ["label"]))
}